export default __webpack_public_path__ + "static/media/molly.3ffe17f9.png";